import React,{useState, useEffect} from 'react';
import PropTypes from "prop-types";
import BodyMetrics from './BodyMetrics';
import convert from "convert-units";
import userProfileDesktop from '../assets/images/default-user-profile-desktop.png';
import userProfileMobile from '../assets/images/default-user-profile-mobile.png';
import { calculateBMI, toSentenceCase } from '../utils/utils';

const UserProfile = ({  weight: initialWeight,
  height: initialHeight, firstName, gender, age, assessmentId, weightUnits, heightUnits }) => {
    
  const [height, setHeight] = useState(initialHeight);
  const [weight, setWeight] = useState(initialWeight);

  const displayAge = age ? `, ${age} years` : '--';

 useEffect(() => {
  // Guard: if no values, clear and return
  if (!initialHeight || !initialWeight) {
    setHeight(null);
    setWeight(null);
    return;
  }

  let convertedHeight = initialHeight;
  let convertedWeight = initialWeight;

  if (heightUnits === "metric") {
    convertedHeight = parseFloat(convert(initialHeight).from("cm").to("m").toFixed(2));
  } else if (heightUnits === "imperial") {
    convertedHeight = Number(convert(initialHeight).from("in").to("m").toFixed(2));
  }

  if (weightUnits === "imperial") {
    convertedWeight = Number(convert(initialWeight).from("lb").to("kg").toFixed(2));
  }

  setHeight(convertedHeight);
  setWeight(convertedWeight);

}, [initialHeight, initialWeight, heightUnits, weightUnits]); // <-- add units to deps too

 
useEffect(() => {
  if (assessmentId === null) {
    setHeight(null);
    setWeight(null);
  }
}, [assessmentId]);

  const bmi = calculateBMI(weight, height)
  return (
    <div className="user-profile-section">
      <div className="user-profile">
        <div className=' d-flex justify-content-between'>
          <div className="user-info d-flex flex-column justify-content-center">
            <h3 className="user-name text-mhc-green text-color-for-mhc">{toSentenceCase(firstName)}</h3>
            <p className="user-details">
              {toSentenceCase(gender?.trim())}
              {displayAge}
            </p>
          </div>
        </div>
        {height && weight && bmi ? <BodyMetrics height={height} weight={weight} bmi={bmi} assessmentId={assessmentId} /> : null}
      </div>
    </div>
  );
};
UserProfile.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  weight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  firstName: PropTypes.string,
  gender: PropTypes.string,
  age: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isMobile: PropTypes.bool,
  assessmentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
export default UserProfile;